import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  //#region properties
  loginForm: any = FormGroup;
  forgotPasswordForm: any = FormGroup;
  resetPasswordForm: any = FormGroup;
  registerForm: any = FormGroup;
  userForm: any = FormGroup;
  programPeriodForm: any = FormGroup;
  preferredPartnerForm: any = FormGroup;
  preferredVendorForm: any = FormGroup;
  fileupload: FormData = new FormData();
  contractupload: FormData = new FormData();
  fileBulkupload: FormData = new FormData();
  accountForm: any = FormGroup;
  siteForm: any = FormGroup;
  investmentCustomerSiteForm: any = FormGroup;
  investmentNewCustomerForm: any = FormGroup;
  investmentInvoiceForm: any = FormGroup;
  investmentForm: any = FormGroup;

  billSiteVendorForm: any = FormGroup;
  billNewQbVendorForm: any = FormGroup;
  billPaybevInvoiceForm: any = FormGroup;
  billForm: any = FormGroup;

  expenseForm: any = FormGroup;
  mapSupplierForm: any = FormGroup

  refundForm: any = FormGroup;

  creditInternalTransferForm: any = FormGroup;
  debitInternalTransferForm: any = FormGroup;

  rolesForm: any = FormGroup;
  agencysForm: any = FormGroup;
  badgeForm: any = FormGroup;
  underReviewForm: any = FormGroup;
  accountTypeForm: any = FormGroup;
  resourceForm: any = FormGroup;
  repsForm: any = FormGroup;
  supplierDetailsForm: any = FormGroup;
  supplierRequirementForm: any = FormGroup;
  profileForm: any = FormGroup;
  tagsGroupForm: any = FormGroup;
  tagForm: any = FormGroup;
  emailForm: any = FormGroup;

  announcementForm: any = FormGroup;
  retailProgramsForm: any = FormGroup;

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (
      control.value !== this.resetPasswordForm.controls.Password.value
    ) {
      return { confirm: true, error: true };
    }
    return {};
  };
  fb: any;
  //#endregion

  //#region functions
  loginForm_fb() {
    this.loginForm = this._fb.group({
      Email: [
        null,
        [
          Validators.required,
          Validators.pattern(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/),
        ],
      ],
      Password: [null, [Validators.required]],
    });
  }
  emailForm_fb() {
    this.emailForm = this._fb.group({
      from: ['', [Validators.required]],
      to: [
        ,
        [
          Validators.required,
          Validators.pattern(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/),
        ],
      ],
      cc: [''],
      subject: [, [Validators.required]],
      body: ['', [Validators.required]],
      includeInMail: [false],
    });
  }

  forgotPasswordForm_fb() {
    this.forgotPasswordForm = this._fb.group({
      Email: [null, [Validators.required, Validators.email]],
    });
  }

  resetPasswordForm_fb() {
    this.resetPasswordForm = this._fb.group({
      Password: [null, [Validators.required]],
      ConfirmPassword: [
        null,
        [Validators.required, this.confirmationValidator],
      ],
      restPasswordToken: [],
    });
  }

  registerForm_fb() {
    this.registerForm = this._fb.group({
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      phoneNumber: [null, [Validators.required]],
      emailAddress: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  userForm_fb() {
    this.userForm = this._fb.group({
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      emailAddress: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/)]],
      role: ['', Validators.required],
      phoneNumber: [''],
      is2FArequired: [false],
      agency: ['', Validators.required],
      // accounts: ['', Validators.required],
      sites: ['', Validators.required],
      supplierReps: [''],
      isUserActive: [true],
      isChangePasswordRequired: [false],
    });
  }
  preferredPartnerForm_fb() {
    this.preferredPartnerForm = this._fb.group({
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      customerDisplayName: [
        '',
        [Validators.required, Validators.pattern(/.*\S.*/)],
      ],
      emailAddress: ['', Validators.required],
      phoneNumber: ['', [Validators.pattern(/\d{10}/)]],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      zipcode: [''],
      country: ['USA'],
      ispreferredPartnerActive: [true],
    });
  }
  preferredVendorForm_fb() {
    this.preferredVendorForm = this._fb.group({
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      vendorDisplayName: [
        '',
        [Validators.required, Validators.pattern(/.*\S.*/)],
      ],
      emailAddress: ['', Validators.required],
      phoneNumber: ['', [Validators.pattern(/\d{10}/)]],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      zipcode: [''],
      country: ['USA'],
      ispreferredVendorActive: [true],
    });
  }
  programPeriodForm_fb() {
    this.programPeriodForm = this._fb.group({
      labelName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      programStartMonth: ['', Validators.required],
      programStartYear: ['', Validators.required],
      programEndMonth: ['', Validators.required],
      programEndYear: ['', Validators.required],
      isProgramPeriodActive: [{ value: true, disabled: false }],
    });
  }
  accountForm_fb() {
    this.accountForm = this._fb.group({
      accountProfile: [],
      accountName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      address1: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      address2: [''],
      city: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      state: ['', Validators.required],
      zipcode: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      country: ['USA', Validators.required],
      agency: ['', Validators.required],
      type: ['', Validators.required],
      status: ['1'],
      contractDate: [''],

      // New Fields for Assignment
      assignedTo: [0], // Stores the selected role
    });
  }
  siteForm_fb() {
    this.siteForm = this._fb.group({
      siteProfile: [],
      siteName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      isSameAddress: [false],
      accountName: ['', Validators.required],
      address1: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      address2: [''],
      city: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      state: ['', Validators.required],
      zipcode: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      country: ['USA', Validators.required],
      siteType: ['', Validators.required],
      status: ['1'],
      nonAlcStatus: [false],
      programVisibility: [false],
      tagVisibility: [false],
      class: ['', Validators.required],
      category: ['', Validators.required],
      product: ['', Validators.required],
      processFee: ['', Validators.required],
      nonAlcFee: ['', Validators.required],
      startingBalance: ['', Validators.required],
      date: ['', Validators.required],
    });
  }
  investmentCustomerSiteForm_fb() {
    this.investmentCustomerSiteForm = this._fb.group({
      site: ['', [Validators.required]],
      partners: ['', [Validators.required]],
      companyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      // representativeName: ['', Validators.required],
      address1: ['', [Validators.pattern(/.*\S.*/)]],
      address2: [''],
      city: ['', [Validators.pattern(/.*\S.*/)]],
      state: [''],
      zipcode: ['', [Validators.pattern(/.*\S.*/)]],
      country: ['USA'],
      emailAddress: ['', Validators.required],
      phoneNumber: [''],
      mobileNumber: [''],
    });
  }
  billSiteVendorForm_fb() {
    this.billSiteVendorForm = this._fb.group({
      site: ['', [Validators.required]],
      vendor: ['', [Validators.required]],
      vendorName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      address1: ['', [Validators.pattern(/.*\S.*/)]],
      address2: [''],
      internationalAddress: [''],
      city: ['', [Validators.pattern(/.*\S.*/)]],
      state: [''],
      zipcode: ['', [Validators.pattern(/.*\S.*/)]],
      country: [''],
      siteVendoremailAddress: [null],
      phoneNumber: ['', [Validators.pattern(/\d{10}/)]],
      // w9Attachment: ['', [Validators.required]],
    });
  }
  investmentNewCustomerForm_fb() {
    this.investmentNewCustomerForm = this._fb.group({
      // representativeName: ['', Validators.required],
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      emailAddress: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      mobileNumber: ['', [Validators.pattern(/\d{10}/)]],
      isExistingParentCompany: [],
      parentCompanyExisting: ["", [Validators.required]],
      parentCompanyNew: ['', [Validators.required]],
      // companyName: ['', Validators.required],
      newParentCompanyName: ['', Validators.required],
      netTerms: ['', [Validators.required]],
      arEmailAddress: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/)]],
      address1: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      address2: [''],
      city: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      state: ['', Validators.required],
      zipcode: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      country: ['USA', Validators.required],
    });
  }
  billNewQbVendorForm_fb() {
    this.billNewQbVendorForm = this._fb.group({
      companyName: ['', Validators.required],
      vendorName: ['', Validators.required],
      address1: ['', [Validators.pattern(/.*\S.*/)]],
      address2: [''],
      city: ['', [Validators.pattern(/.*\S.*/)]],
      state: [''],
      zipcode: ['', [Validators.pattern(/.*\S.*/)]],
      country: [''],
      BusinessRegNo: [''],
      phoneNumber: [''],
      emailAddress: [null, [Validators.email]],
      paymentType: ['3', [Validators.required]],
      netTerms: ['6', [Validators.required]],
      trackPayment: [false],
    });
  }
  investmentInvoiceForm_fb() {
    this.investmentInvoiceForm = this._fb.group({
      product: ['', [Validators.required]],
      class: ['', Validators.required],
      scheduledDate: ['', Validators.required],
      description: [''],
      memo: [''],
      processFee: ['', Validators.required],
      amount: ['', Validators.required],
      feePercent: ['', Validators.required],
      isEstimate: [false, Validators.required],
    });
  }
  billPaybevInvoiceForm_fb() {
    this.billPaybevInvoiceForm = this._fb.group({
      category: ['', [Validators.required]],
      class: ['', Validators.required],
      billNo: ['', Validators.required],
      billAttachment: [''],
      description: [''],
      memo: [''],
      amount: ['', Validators.required],
      serviceFee: ['', Validators.required],
      serviceRequest: ['', [Validators.required]],
      paymentDate: ['', [Validators.required]],
    });
  }
  investmentForm_fb() {
    this.investmentForm = this._fb.group({
      arrivalDate: ['', [Validators.required]],
      programPeriod: ['', Validators.required],
      isNonAlc: [false, Validators.required],
      isBalanceTransfer: [false],
    });
  }
  refundForm_fb() {
    this.refundForm = this._fb.group({
      programPeriod: ['', Validators.required],
      isNonAlc: [false, Validators.required],
    });
  }
  expenseForm_fb() {
    this.expenseForm = this._fb.group({
      programPeriod: ['', Validators.required],
      tags: ['', Validators.required],
      isNonAlc: [false, Validators.required],
    });
  }
  debitInternalTransferForm_fb() {
    this.debitInternalTransferForm = this._fb.group({
      debitProgramPeriod: ['', Validators.required],
      debitTags: ['', Validators.required],
      debitIsNonAlc: [false],
    });
  }
  creditInternalTransferForm_fb() {
    this.creditInternalTransferForm = this._fb.group({
      programPeriod: ['', Validators.required],
      tags: ['', Validators.required],
      isNonAlc: [false],
    });
  }

  billForm_fb() {
    this.billForm = this._fb.group({
      programPeriod: ['', Validators.required],
      tags: ['', Validators.required],
      isNonAlc: [false, Validators.required],
    });
  }
  rolesForm_fb() {
    this.rolesForm = this._fb.group({
      roleName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      description: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      isActiveRole: [true],
      isBrooklynActive: [false],
    });
  }
  agencysForm_fb() {
    this.agencysForm = this._fb.group({
      agencyProfile: [],
      agencyName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lightColor: ['', [Validators.required]],
      darkColor: ['', [Validators.required]],
      isActiveagency: [true],
    });
  }
  badgeForm_fb() {
    this.badgeForm = this._fb.group({
      badgeName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      color: ['', [Validators.required]],
      // transactionType: ['', [Validators.required]],
      // isActiveagency: [true],
    });
  }
  underReviewForm_fb() {
    this.underReviewForm = this._fb.group({
      reason: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      color: ['', [Validators.required]],
      emailCopy: [''],
    });
  }
  accountTypeForm_fb() {
    this.accountTypeForm = this._fb.group({
      accountTypeName: [
        '',
        [Validators.required, Validators.pattern(/.*\S.*/)],
      ],
      isActive: [true],
    });
  }
  resourceForm_fb() {
    this.resourceForm = this._fb.group({
      resourceName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      link: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/
          ),
        ],
      ],
    });
  }

  private phoneNumberValidator(control: FormControl): { [key: string]: any } | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }

    const value = control.value.toString();
    const digitCount = (value.match(/\d/g) || []).length;

    if (digitCount === 10) {
      return null; // Valid
    }

    return { invalidPhoneFormat: true };
  }


  repsForm_fb() {
    this.repsForm = this._fb.group({
      repsProfile: [],
      linkedInProfilelnk: [''],
      location: [''],
      title: [''],
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.pattern(/.*\S.*/)]],
      mobileNumber: ['', [this.phoneNumberValidator.bind(this)]],
    });
  }
  // supplierForm_fb() {
  //   this.supplierForm = this._fb.group({
  //     supplierName: ['', [Validators.required]],
  //     agency: ['', [Validators.required]],
  //     supplierType: ['', [Validators.required]],
  //     documentDate: [''],
  //     status: [true],
  //     nonAlcStatus: [false],
  //     assignment: [''],
  //     fiscalStart: [''],
  //     desc: [''],
  //     notes: [''],
  //   });
  // }
  supplierDetailsForm_fb() {
    this.supplierDetailsForm = this._fb.group({
      supplierName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      agency: ['', [Validators.required]],
      supplierType: [''],
      documentDate: [''],
      status: [true],
      nonAlcStatus: [false],
      assignment: [''],
    });
  }
  supplierRequirementForm_fb() {
    this.supplierRequirementForm = this._fb.group({
      isInvoice: [false],
      terms: [''],
      paymentMethod: [''],
      fiscalStart: [''],
      desc: [''],
      notes: [''],
    });
  }
  mapSupplierForm_fb() {
    this.mapSupplierForm = this._fb.group({
      QBOCustomer: ['', Validators.required],
    });
  }

  profileForm_fb() {
    this.profileForm = this._fb.group({
      firstName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      lastName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/\d{10}/)]],
      title: [''],
      location: [''],
      linkedinUrl: [
        '',
        Validators.pattern(
          /^(|https?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?)$/i
        ),
      ],
    });
  }

  tagsGroupForm_fb() {
    this.tagsGroupForm = this._fb.group({
      tagGroupName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      // tagGroupColor: ['', Validators.required],
    });
  }

  tagForm_fb() {
    this.tagForm = this._fb.group({
      tagName: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      tagGroup: ['', Validators.required],
    });
  }
  announcementForm_fb() {
    this.announcementForm = this._fb.group({
      title: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      desc: ['', [Validators.required, Validators.pattern(/.*\S.*/)]],
      start: ['', Validators.required],
      end: ['', Validators.required],
      isActive: [true],
    });
  }
  retailProgramsForm_fb() {
    this.retailProgramsForm = this._fb.group({
      programName: ['', [Validators.required, Validators.maxLength(50)]],
      siteId: ['', [Validators.required, Validators.maxLength(50)]],
      // siteName: ['', [Validators.required, Validators.maxLength(50)]],
      isActiveRetailPrograms: [true],
      invoiceDescriptionText: ['', [Validators.maxLength(1000)]],
      banner: ['', [Validators.required]],
      logo: ['', [Validators.required]]
    });
  }
  //#endregion
  constructor(private _fb: FormBuilder) { }
}
